var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_vm._l((_vm.inputValue),function(_,index){return [_vm._l((_vm.slotsList),function(slotName){return [_vm._t(slotName,null,null,{ index: index })]})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }